
import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { StateService } from './../state.service';
import { AlertService } from './../alert.service';
import { ToastService } from './../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';

export const CONFIG_MASTER_STAFF_LIST = [
  {id:'S001', name: '木下 まさみ', unit: '１階ユニット', icon:'./assets/imgs/v0.0.4/no_login_staff.png'},
  {id:'S002', name: '山田 太郎',   unit: '１階ユニット', icon:'./assets/imgs/v0.0.4/no_login_staff.png'},
  {id:'S003', name: '佐々木 忍',   unit: '２階ユニット', icon:'./assets/imgs/v0.0.4/no_login_staff.png'},
  {id:'S004', name: '吉岡 太一',   unit: '２階ユニット', icon:'./assets/imgs/v0.0.4/no_login_staff.png'},
];

@Injectable()
export class ApiStaffService extends ApiBaseService {

  protected headers: Headers;
  protected apiName = '[ ApiStaffService ]';
  isLoading: boolean = true;

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }

  get() {
  }

  /**
   * スタッフ一覧取得API
   * @return void
   */
  list(): Promise<any> {
    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: this.apiAuthStore.url + '/api/v1/staffs',
        body: {}, headers: this.headers}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }

  /**
   * スタッフ情報登録
   * @param params
   * @return Promise<any>
   */
  post(params): Promise<any> {
    this.isLoading = true
    return new Promise((resolve) => {
      return this.doPost({
        url: this.apiAuthStore.url + '/api/v1/staff',
        body: params, headers: this.headers
      }).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }

  /**
   * スタッフ情報一括登録
   * @param params
   * @return Promise<any>
   */
  bulkPost(params): Promise<any> {
    this.isLoading = true
    return new Promise((resolve) => {
      return this.doPost({
        url: this.apiAuthStore.url + '/api/v1/staff/bulk',
        body: params, headers: this.headers
      }).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }

  /**
   * スタッフ情報更新
   * @param params
   * @return Promise<any>
   */
  update(params): Promise<any> {
    this.isLoading = true
    return new Promise((resolve) => {
      return this.doPost({
        url: this.apiAuthStore.url + `/api/v1/staff/${params.staffId}`,
        body: params, headers: this.headers
      }).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }

  /**
   * スタッフ情報削除
   * @param params
   * @return Promise<any>
   */
  delete(params): Promise<any> {
    this.isLoading = true
    return new Promise((resolve) => {
      return this.doDelete({
        url: this.apiAuthStore.url + `/api/v1/staff/${params.staffId}`,
        body: params, headers: this.headers
      }).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }

  /**
   * スタッフ情報論理削除
   * @param params
   * @return Promise<any>
   */
  softDelete(params): Promise<any> {
    this.isLoading = true
    return new Promise((resolve) => {
      return this.doPost({
        url: this.apiAuthStore.url + `/api/v1/staff/${params.staffId}/soft`,
        body: params,
        headers: this.headers
      }).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }

  create() {
  }


}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-staff.service.ts